import { get as _get } from 'lodash';

import global from './global';

const translate = (key: string, lang: string): string => {
    return _get(global, [key, lang], key);
};

export default translate;
